<template>
    <div class="hold-transition login-page">
        <div class="login-box">
         <img src="@/assets/logo.png" id="logo" />

            <div class="card">
                <div class="card-body login-card-body">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    
    #logo {
        width: 300px;
        margin: 0 auto 20px auto;
        display: block;
    }

    .hold-transition {
        background: url(@/assets/back.jpg);
        background-size: cover;
    }
    
    @media only screen and (max-width: 1024px) {
        .hold-transition {
            background: url(@/assets/back.jpg);
            background-size: cover;
        }
    }
    
</style>

<script>
    export default {
        mounted() {
            document.body.classList.add('hold-transition', 'login-page');
        },
    }
</script>